import { render, staticRenderFns } from "./InsightTransactionsModal.vue?vue&type=template&id=b4244e72&"
import script from "./InsightTransactionsModal.vue?vue&type=script&lang=js&"
export * from "./InsightTransactionsModal.vue?vue&type=script&lang=js&"
import style0 from "./InsightTransactionsModal.vue?vue&type=style&index=0&id=b4244e72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports